// Horizon Techline - Everyday Tech, Thoughtfully Chosen
// Brand operator: Arah Capital Group LLC

// ============================================
// SITE IMAGES - Electronics / Tech Theme (stored locally, brand-free stock)
// ============================================
export const siteImages = {
  heroMain: '/banners/hz-hero.jpg',
  heroSecondary: '/banners/hz-promo.jpg',
  heroLifestyle: '/banners/hz-about.jpg',
  ctaBackground: '/banners/hz-cta.jpg',
  featuredBackground: '/banners/hz-cta.jpg',
  powerBackground: '/banners/hz-promo.jpg',
  shopBanner: '/banners/hz-shop.jpg',
  aboutBanner: '/banners/hz-about.jpg',
  contactBanner: '/banners/hz-contact.jpg',
  returnsBanner: '/banners/hz-shop.jpg',
  privacyBanner: '/banners/hz-about.jpg',
};

export const SHIPPING_NOTICE = 'Free USPS shipping across the United States';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8448442314horizontechline';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(844) 844-2314',
  email: 'contactus@horizontechline.com',
  corpName: 'Arah Capital Group LLC',
  address: {
    street: '1331 W Haddington Ct',
    city: 'Palatine',
    state: 'IL',
    zip: '60067-6616',
    country: 'United States'
  }
};

// Return address must remain unchanged.
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// GADGET PRODUCT CATALOG (14 Products)
// Prices fixed to required processor MID points:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// Product names, images and descriptions sourced from djonesonlineelectronics.com
// ============================================
export const products = [
  // ===== POWER & CHARGING =====
  {
    id: "portable-power-bank",
    name: "Portable Power Bank",
    slug: "portable-power-bank",
    sku: "BTS-PWR-001",
    price: 9.63,
    image: "/products/gadgets/power-bank.webp",
    badge: "Deal",
    categoryId: "power-charging",
    categorySlug: "power-charging",
    description: "A high-capacity portable power bank with a 10,000mAh battery, perfect for charging your phone, tablet or earbuds on the move. Slim enough to slip into any pocket, it keeps your essential devices topped up all day long.",
    keyBenefits: ["10,000mAh capacity", "Pocket-sized and lightweight", "Charges phones, tablets and earbuds"],
    usage: "Charge the power bank fully, then connect your device with a USB cable for a fast top-up anywhere you go.",
    features: ["10,000mAh", "Dual USB", "Slim Design", "LED Charge Meter"],
    inStock: true
  },

  // ===== AUDIO & SOUND =====
  {
    id: "bluetooth-computer-speaker-system",
    name: "Bluetooth Computer Speaker System",
    slug: "bluetooth-computer-speaker-system",
    sku: "BTS-AUD-001",
    price: 12.84,
    image: "/products/gadgets/computer-speaker-system.jpg",
    badge: "Best Value",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "Enhance your desktop experience with this futuristic Bluetooth computer speaker system. Crisp highs and punchy bass fill the room, while wireless pairing and a wired option let you connect to laptops, monitors and phones in seconds.",
    keyBenefits: ["Rich stereo desktop sound", "Wireless Bluetooth + wired input", "Compact space-saving footprint"],
    usage: "Pair over Bluetooth or plug in the aux cable, then enjoy full-range audio for music, calls and gaming.",
    features: ["Bluetooth 5.0", "Stereo Pair", "USB Powered", "Aux Input"],
    inStock: true
  },
  {
    id: "smart-bluetooth-speaker-led",
    name: "Smart Bluetooth Speaker with Color-Changing LED",
    slug: "smart-bluetooth-speaker-led",
    sku: "BTS-AUD-002",
    price: 19.26,
    image: "/products/gadgets/smart-led-speaker.jpg",
    badge: "Popular",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "Experience a fusion of sound and light with this Smart Bluetooth Speaker featuring color-changing LED lighting. Vibrant, pulsing colors set the mood while a powerful driver delivers clear, room-filling audio for any occasion.",
    keyBenefits: ["Color-changing LED light show", "Room-filling wireless sound", "Portable and rechargeable"],
    usage: "Switch on the LED mode, pair your phone over Bluetooth and let the lights dance to your favorite tracks.",
    features: ["RGB LED", "Bluetooth", "Rechargeable", "Portable"],
    inStock: true
  },
  {
    id: "mini-smart-bluetooth-speaker-silicone",
    name: "Mini Smart Bluetooth Speaker with Silicone Case",
    slug: "mini-smart-bluetooth-speaker-silicone",
    sku: "BTS-AUD-003",
    price: 19.37,
    image: "/products/gadgets/mini-silicone-speaker.jpg",
    badge: "Best Seller",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "The Mini Smart Bluetooth Speaker with Silicone Case is a compact, stylish audio companion that goes wherever you do. Its soft-touch protective case adds grip and durability, while the driver punches well above its size.",
    keyBenefits: ["Protective soft silicone case", "Big sound from a tiny body", "Clip-and-go portability"],
    usage: "Clip it to a bag or set it on a shelf, pair over Bluetooth and enjoy your playlist on the move.",
    features: ["Silicone Case", "Bluetooth", "Clip Design", "Rechargeable"],
    inStock: true
  },
  {
    id: "touch-control-true-wireless-earbuds",
    name: "Touch-Control True Wireless Earbuds",
    slug: "touch-control-true-wireless-earbuds",
    sku: "BTS-AUD-004",
    price: 28.89,
    image: "/products/gadgets/wireless-earbuds.jpg",
    badge: "Pro Pick",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "Step into a world of crystal-clear sound with these compact Touch-Control True Wireless Earbuds. Intuitive tap gestures manage music and calls, while the charging case delivers hours of extra playtime between charges.",
    keyBenefits: ["Intuitive touch controls", "True wireless freedom", "Charging case for all-day power"],
    usage: "Pop the earbuds out of the case to auto-pair, then tap to play, pause or answer calls hands-free.",
    features: ["Touch Control", "Charging Case", "Bluetooth 5.0", "Built-in Mic"],
    inStock: true
  },
  {
    id: "modern-wireless-headphones",
    name: "Modern Wireless Headphones",
    slug: "modern-wireless-headphones",
    sku: "BTS-AUD-005",
    price: 142.16,
    image: "/products/gadgets/wireless-headphones.jpg",
    badge: "Premium",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "Experience exceptional audio quality with these sleek Modern Wireless Headphones. Plush over-ear cushions and a refined design keep you comfortable for hours, while wireless connectivity keeps your music tangle-free.",
    keyBenefits: ["Balanced high-fidelity sound", "Plush over-ear comfort", "Long-lasting wireless battery"],
    usage: "Power on, pair over Bluetooth and enjoy immersive audio for music, movies and calls all day.",
    features: ["Over-Ear", "Bluetooth", "Long Battery", "Foldable"],
    inStock: true
  },
  {
    id: "wireless-noise-cancelling-headphones",
    name: "Wireless Noise-Cancelling Headphones",
    slug: "wireless-noise-cancelling-headphones",
    sku: "BTS-AUD-006",
    price: 227.48,
    image: "/products/gadgets/noise-cancelling-headphones.jpg",
    badge: "Editor's Choice",
    categoryId: "audio-sound",
    categorySlug: "audio-sound",
    description: "Immerse yourself in high-definition audio with these Luxe Wireless Noise-Cancelling Headphones. Active noise cancellation silences the world around you, so every note, podcast and call comes through with stunning clarity.",
    keyBenefits: ["Active noise cancellation", "High-definition audio drivers", "Premium cushioned comfort"],
    usage: "Switch on ANC to block ambient noise, then pair over Bluetooth for focused, distraction-free listening.",
    features: ["Active ANC", "Hi-Def Drivers", "Bluetooth", "Travel Ready"],
    inStock: true
  },

  // ===== GAMING GEAR =====
  {
    id: "azure-ice-mechanical-keyboard",
    name: "Azure Ice Mechanical Keyboard",
    slug: "azure-ice-mechanical-keyboard",
    sku: "BTS-GAM-001",
    price: 58.11,
    image: "/products/gadgets/azure-mechanical-keyboard.jpg",
    badge: "Popular",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Make a statement at your desk with this frost-blue mechanical keyboard. Translucent keycaps glow with crisp backlighting while tactile mechanical switches deliver a satisfying, responsive typing and gaming experience.",
    keyBenefits: ["Tactile mechanical switches", "Icy backlit keycaps", "Durable gaming-grade build"],
    usage: "Plug in via USB, choose your lighting effect and enjoy fast, precise keystrokes for work or play.",
    features: ["Mechanical", "RGB Backlit", "Anti-Ghosting", "USB Wired"],
    inStock: true
  },
  {
    id: "wireless-bluetooth-gaming-mouse",
    name: "Wireless Bluetooth Gaming Mouse",
    slug: "wireless-bluetooth-gaming-mouse",
    sku: "BTS-GAM-002",
    price: 77.48,
    image: "/products/gadgets/wireless-gaming-mouse.jpg",
    badge: "Pro Pick",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Unleash peak gaming performance with this High-Performance Wireless Bluetooth Gaming Mouse. A high-precision sensor, adjustable DPI and ergonomic shape give you the speed and control to dominate every match.",
    keyBenefits: ["High-precision optical sensor", "Adjustable DPI settings", "Ergonomic low-latency design"],
    usage: "Connect wirelessly, set your DPI on the fly and enjoy responsive, cable-free aim in any game.",
    features: ["Adjustable DPI", "Wireless", "Ergonomic", "Low Latency"],
    inStock: true
  },

  // ===== CREATORS & DISPLAYS =====
  {
    id: "classic-black-graphic-drawing-tablet",
    name: "Classic Black Graphic Drawing Tablet",
    slug: "classic-black-graphic-drawing-tablet",
    sku: "BTS-CRE-001",
    price: 318.72,
    image: "/products/gadgets/graphic-drawing-tablet.png",
    badge: "Creator",
    categoryId: "creators-displays",
    categorySlug: "creators-displays",
    description: "The Classic Black Graphic Drawing Tablet is a versatile tool designed for both aspiring and professional artists. A responsive pen and generous active area make sketching, illustrating and photo editing feel natural and precise.",
    keyBenefits: ["Pressure-sensitive pen input", "Large active drawing area", "Works with major creative apps"],
    usage: "Connect to your computer, launch your favorite drawing app and start creating with the included stylus.",
    features: ["Pressure Sensitive", "Large Area", "Battery-Free Pen", "App Compatible"],
    inStock: true
  },
  {
    id: "ultra-wide-curved-computer-monitor",
    name: "Ultra-Wide Curved Computer Monitor",
    slug: "ultra-wide-curved-computer-monitor",
    sku: "BTS-CRE-002",
    price: 489.36,
    image: "/products/gadgets/ultrawide-monitor.png",
    badge: "Premium",
    categoryId: "creators-displays",
    categorySlug: "creators-displays",
    description: "Immersive 34-inch ultra-wide curved monitor with WQHD 3440x1440 resolution and a 165Hz refresh rate. The sweeping curve wraps visuals around your field of view for smoother gaming, richer editing and effortless multitasking.",
    keyBenefits: ["34-inch WQHD ultra-wide panel", "165Hz smooth refresh rate", "Immersive curved display"],
    usage: "Connect over HDMI or DisplayPort, tilt to your ideal angle and enjoy a panoramic, glare-reduced view.",
    features: ["34in Curved", "3440x1440", "165Hz", "HDMI/DP"],
    inStock: true
  },
  {
    id: "advanced-e-book-reader-digital-pen",
    name: "Advanced e-Book Reader with Digital Pen",
    slug: "advanced-e-book-reader-digital-pen",
    sku: "BTS-CRE-003",
    price: 612.44,
    image: "/products/gadgets/ebook-reader.jpg",
    badge: "New",
    categoryId: "creators-displays",
    categorySlug: "creators-displays",
    description: "The Advanced e-Book Reader with Digital Pen is a cutting-edge device designed for reading, note-taking and sketching in one. The glare-free e-paper display is easy on the eyes, while the included pen turns any page into a notebook.",
    keyBenefits: ["Paper-like glare-free display", "Write and annotate with the pen", "Massive built-in library storage"],
    usage: "Load your books and documents, then read, highlight and jot handwritten notes with the digital pen.",
    features: ["E-Paper Display", "Digital Pen", "Long Battery", "Large Storage"],
    inStock: true
  },
  {
    id: "graphic-tablet-monitor-stylus",
    name: "Graphic Tablet Monitor with Shortcut Keys and Digital Stylus",
    slug: "graphic-tablet-monitor-stylus",
    sku: "BTS-CRE-004",
    price: 784.88,
    image: "/products/gadgets/graphic-tablet-monitor.png",
    badge: "Pro Kit",
    categoryId: "creators-displays",
    categorySlug: "creators-displays",
    description: "The ProArtist Graphic Tablet Monitor is designed to cater to both aspiring and professional creators. Draw directly on the vivid screen with the pressure-sensitive stylus, and speed up your workflow with programmable shortcut keys.",
    keyBenefits: ["Draw directly on the screen", "Programmable shortcut keys", "High color-accuracy display"],
    usage: "Connect to your PC, calibrate the pen and illustrate directly on the full-color display for pixel-perfect work.",
    features: ["Pen Display", "Shortcut Keys", "Color Accurate", "Tilt Support"],
    inStock: true
  },

  // ===== SMART & IMMERSIVE =====
  {
    id: "elite-all-in-one-vr-headset",
    name: "Elite All-In-One Virtual Reality Headset",
    slug: "elite-all-in-one-vr-headset",
    sku: "BTS-SMT-001",
    price: 999.00,
    image: "/products/gadgets/vr-headset.png",
    badge: "Flagship",
    categoryId: "smart-immersive",
    categorySlug: "smart-immersive",
    description: "Dive into immersive virtual worlds without a PC or console tethering you down. This Elite All-In-One Virtual Reality Headset packs sharp dual displays, room-scale tracking and intuitive motion controllers into one standalone device.",
    keyBenefits: ["Standalone — no PC required", "Sharp dual-display immersion", "Room-scale motion tracking"],
    usage: "Slip on the headset, grab the motion controllers and step straight into games, fitness and virtual experiences.",
    features: ["Standalone", "Dual Display", "Motion Controllers", "Room-Scale"],
    inStock: true
  },
];

export const categories = [
  {
    id: "audio-sound",
    name: "Audio & Sound",
    slug: "audio-sound",
    description: "Wireless speakers, earbuds and headphones tuned for rich, room-filling sound",
    image: "/products/gadgets/wireless-headphones.jpg",
    productCount: 6
  },
  {
    id: "gaming-gear",
    name: "Gaming Gear",
    slug: "gaming-gear",
    description: "Mechanical keyboards and precision mice built to give you the competitive edge",
    image: "/products/gadgets/azure-mechanical-keyboard.jpg",
    productCount: 2
  },
  {
    id: "creators-displays",
    name: "Creators & Displays",
    slug: "creators-displays",
    description: "Drawing tablets, pen displays, e-readers and ultra-wide monitors for makers",
    image: "/products/gadgets/graphic-tablet-monitor.png",
    productCount: 4
  },
  {
    id: "power-charging",
    name: "Power & Charging",
    slug: "power-charging",
    description: "Portable power banks and charging essentials to keep every device alive",
    image: "/products/gadgets/power-bank.webp",
    productCount: 1
  },
  {
    id: "smart-immersive",
    name: "Smart & Immersive",
    slug: "smart-immersive",
    description: "Next-gen VR and smart devices that bring immersive experiences home",
    image: "/products/gadgets/vr-headset.png",
    productCount: 1
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Handpicked Tech', description: 'A tight, curated lineup of gadgets worth owning — no filler, no guesswork' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order, no minimum required' },
  { id: 3, title: '30-Day Returns', description: 'Changed your mind? Send it back within 30 days, hassle-free' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and privacy-first handling of your data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Made to Perform', description: 'Every gadget is picked for real-world speed, clarity and reliability' },
  { id: 2, title: 'Detail Obsessed', description: 'Crisp audio, sharp displays and responsive controls in every device' },
  { id: 3, title: 'Creator Approved', description: 'Gear that keeps gamers, artists and remote workers in their flow' },
  { id: 4, title: 'Fair, Honest Pricing', description: 'Straightforward prices on the tech you actually want' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated collection of smart electronics and everyday tech.' },
  { id: 2, title: 'Choose', description: 'Pick the audio, gaming or creator gear that fits your setup.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with fast, secure and encrypted payment.' },
  { id: 4, title: 'Power Up', description: 'Unbox, connect and get more done with your new gadget.' }
];
